module.exports = __webpack_public_path__ + "img/arrow.55653bc4.svg";